//          __
//   ____  / /_  ________  ______   _____  _____
//  / __ \/ __ \/ ___/ _ \/ ___/ | / / _ \/ ___/
// / /_/ / /_/ (__  )  __/ /   | |/ /  __/ /
// \____/_.___/____/\___/_/    |___/\___/_/

/* global */

import viewObserver from 'view-observer';
import anime from 'animejs/lib/anime.es.js';
import { stopPlayers } from './youtube';

// ----------------------------------------------------------------------------
//
//
// Fires on Document Ready Event
//
//
// ----------------------------------------------------------------------------
const setupObserver = () => {
  console.log('{ setupObserver }');

  // Elements to observe
  const sliders = document.getElementsByClassName('slider-wrap');
  const splitting = document.getElementsByClassName('splitting');
  const white_bg = document.getElementsByClassName('js-sr_white');
  const wiretext = document.getElementsByClassName('wire-text');
  const chevrons = document.getElementsByClassName('svg-chevrons');
  const home_project = document.getElementsByClassName('js-sr_home');
  const vertical_line = document.getElementsByClassName('line--vertical');
  const horizontal_line = document.getElementsByClassName('line--horizontal');
  const active_links = document.getElementsByClassName('js-link-active');
  const posts = document.getElementsByClassName('js-filter-article');
  const location = document.getElementsByClassName('location');
  const copy_image = document.getElementsByClassName(
    'copy-image-feature__figure'
  );
  const card_link = document.getElementsByClassName('card--link');
  const card_team = document.getElementsByClassName('card--team');
  const card_static = document.getElementsByClassName('card--static');

  const barbaContainer = $('.barba-container');

  // ----------------------------------------------------------------------------
  //
  //
  // 5% visibility
  //
  //
  // ----------------------------------------------------------------------------
  viewObserver({ threshold: 0.05, rootMargin: '25px 0px' })
    .observe([white_bg])

    // ----------------------------------------------------------------------------
    // Enter only
    // ----------------------------------------------------------------------------
    .subscribeOnce([white_bg], (el) => {
      // console.log( 'el: %o', el.target );

      $(el.target).addClass('reveal');
    });

  // ----------------------------------------------------------------------------
  //
  //
  // 10% visibility
  //
  //
  // ----------------------------------------------------------------------------
  viewObserver({ threshold: 0.1, rootMargin: '25px 0px' })
    .observe([chevrons, home_project])

    // ----------------------------------------------------------------------------
    // Enter only
    // ----------------------------------------------------------------------------
    .subscribeOnce([chevrons], (el) => {
      // console.log( 'el: %o', el.target );
      let cp = el.target.getElementsByClassName('p');

      anime({
        targets: cp,
        easing: 'easeOutQuart',
        strokeWidth: [0, '1.5px'],
        strokeDashoffset: [anime.setDashoffset, 0],
        delay: anime.stagger(15),
        duration: anime.stagger(30)
      });
    })

    // ----------------------------------------------------------------------------
    // Enter only
    // ----------------------------------------------------------------------------
    .subscribeOnce([home_project], (el) => {
      // console.log( 'el: %o', el.target );
      $(el.target).addClass('show');
    });

  // ----------------------------------------------------------------------------
  //
  //
  // 30% visibility
  //
  //
  // ----------------------------------------------------------------------------
  viewObserver({ threshold: 0.3, rootMargin: '25px 0px' })
    .observe([
      location,
      copy_image,
      card_link,
      card_static,
      posts,
      card_team,
      vertical_line,
      horizontal_line
    ])

    // ----------------------------------------------------------------------------
    // Enter only
    // ----------------------------------------------------------------------------
    .subscribeOnce([location, copy_image], (el) => {
      // console.log( 'el: %o', el.target );

      $(el.target).addClass('reveal');
    })

    // ----------------------------------------------------------------------------
    // Enter only
    // ----------------------------------------------------------------------------
    .subscribeOnce(
      [
        card_link,
        card_static,
        posts,
        card_team,
        vertical_line,
        horizontal_line
      ],
      (el) => {
        // console.log( 'el: %o', el.target );

        if (!el.target.classList.contains('team-slider')) {
          $(el.target).addClass('show');
        }
      }
    );

  // ----------------------------------------------------------------------------
  //
  //
  // 75% visibility
  //
  //
  // ----------------------------------------------------------------------------
  // viewObserver({ threshold: 0.75, rootMargin: '25px 0px' })
  //   .observe([copy_image])

  //   // ----------------------------------------------------------------------------
  //   // Enter only
  //   // ----------------------------------------------------------------------------
  //   .subscribeOnce([copy_image], el => {
  //     // console.log( 'el: %o', el.target );

  //     $(el.target).addClass('reveal');
  //   });

  // ----------------------------------------------------------------------------
  //
  //
  // 99% visibility
  //
  //
  // ----------------------------------------------------------------------------
  viewObserver({ threshold: 0.99, rootMargin: '25px 0px' })
    .observe([sliders, splitting, wiretext])

    // ----------------------------------------------------------------------------
    // Enter & leave
    // ----------------------------------------------------------------------------
    .subscribe(
      [sliders],
      (el) => {
        const slider = $(el.target).find('.js-sr_slider');
        // console.log( 'slider: %o', slider );

        // console.log( 'ENTER VIEWPORT:el: %o', el.target );
        if (slider.hasClass('slick-initialized')) {
          // don't play team slider
          if ('slider-team' !== $(el.target).attr('id')) {
            slider.slick('slickPlay');
          }
        }
      },
      (el) => {
        const slider = $(el.target).find('.js-sr_slider');
        // console.log( 'slider: %o', slider );

        // console.log( 'LEAVE VIEWPORT: el: %o', el.target );
        if (slider.hasClass('slick-initialized')) {
          slider.slick('slickPause');
          stopPlayers();
        }
      }
    )

    // ----------------------------------------------------------------------------
    // Enter only
    // ----------------------------------------------------------------------------
    .subscribeOnce([splitting, wiretext], (el) => {
      // Check not any of these elements
      if (
        !$(el.target).hasClass('card--team__role') &&
        !$(el.target).hasClass('card--team__name') &&
        !$(el.target).hasClass('card--work__title') &&
        !$(el.target).hasClass('card--work__subtitle') &&
        !$(el.target).hasClass('card--link__copy') &&
        !$(el.target).hasClass('social__link') &&
        !$(el.target).hasClass('site-menu__text') &&
        !$(el.target).parent().hasClass('site-menu__nav')
      ) {
        // console.log( 'el.target: %o', el.target );

        $(el.target).addClass('show');

        const anchors = el.target.getElementsByTagName('A');

        // Reveal anchor underline
        $(anchors).addClass('show');
      }
    });

  // ----------------------------------------------------------------------------
  //
  // Mobile / Tablet only
  //
  // ----------------------------------------------------------------------------
  if (barbaContainer.hasClass('touch')) {
    // Do some calcs based on body width to get a vertical margin value
    // let margin = '-100px';

    // if ($('body').width() >= 768) {
    let margin = '-250px';
    // }

    // ----------------------------------------------------------------------------
    //
    // 90% visibility
    //
    // ----------------------------------------------------------------------------
    viewObserver({ threshold: 0.01, rootMargin: margin + ' 0px' })
      .observe(active_links)

      // ----------------------------------------------------------------------------
      // Enter & Leave
      // ----------------------------------------------------------------------------
      .subscribe(
        active_links,
        (el) => {
          // console.log('ENTER VIEWPORT:el: %o', el.target);
          $(el.target).addClass('active').find('.splitting').addClass('show');
        },
        (el) => {
          // console.log('LEAVE VIEWPORT: el: %o', el.target);
          $(el.target)
            .removeClass('active')
            .find('.splitting')
            .removeClass('show');
        }
      );
  }
};

// ----------------------------------------------------------------------------
//
// Gravity Form reveal
//
// ----------------------------------------------------------------------------
const setupObserverGravityForms = () => {
  const gfields = document.getElementsByClassName('gfield');

  // ----------------------------------------------------------------------------
  //
  //
  // 100% visibility
  //
  //
  // ----------------------------------------------------------------------------
  viewObserver({ threshold: 1, rootMargin: '25px 0px' })
    .observe([gfields])

    // ----------------------------------------------------------------------------
    // Enter only
    // ----------------------------------------------------------------------------
    .subscribeOnce([gfields], (el) => {
      // delay trigger
      let intervalID = setTimeout(function () {
        // console.log( '$(el.target): %o', $(el.target) );
        $(el.target).addClass('show').find('.gfield_label').addClass('show');

        clearTimeout(intervalID);
      }, 500);
    });
};

// ----------------------------------------------------------------------------
//
//
// Fires on Window Load Event
//
//
// ----------------------------------------------------------------------------
const setupObserverOnLoad = () => {
  console.log('{ setupObserverOnLoad }');

  const filter = document.getElementsByClassName('article-filter');

  // ----------------------------------------------------------------------------
  //
  //
  // 99% visibility
  //
  //
  // ----------------------------------------------------------------------------
  viewObserver({ threshold: 0.99, rootMargin: '25px 0px' })
    .observe([filter])

    // ----------------------------------------------------------------------------
    // Enter only
    // ----------------------------------------------------------------------------
    .subscribeOnce([filter], (el) => {
      // console.log( 'el.target: %o', el.target );

      $(el.target).addClass('show');
    });
};

export { setupObserver, setupObserverOnLoad, setupObserverGravityForms };



// WEBPACK FOOTER //
// ./scripts/modules/observer-setup.js